import { useSelector } from "react-redux";
import getServiceProvider from "../store/selectors/getServiceProvider";

const useIpsExclusive = () => {
  const serviceProvider = useSelector(getServiceProvider);
  return (
    serviceProvider.serviceProviderId === "b721df57-7c24-42ce-a156-a5db7a30520b"
  );
};

export default useIpsExclusive;
